import templateUrl from './claim-value-select.component.html';
import { claimTypes } from './claim-types-select.component';

const ROLES_ALL = "ALL";

export const ClaimValueSelectComponent = {
    templateUrl,
    bindings: {
        claimType: "<",
        model: "=",
        onChange: "&"
    },
    controllerAs: "vm",
    controller: class ClaimValueSelectComponent {
        constructor($q, utilityService, icdCorporationService, icdOfficeService,
            roleService, divisionService, teamService) {
            'ngInject';
            this.$q = $q;
            this.utilityService = utilityService;
            this.icdCorporationService = icdCorporationService;
            this.icdOfficeService = icdOfficeService;
            this.roleService = roleService;
            this.divisionService = divisionService;
            this.teamService = teamService;
        }

        $onInit() {
            this.utilityService.showLoading();
            this.loadInitialData()
                .catch(ex => {
                    console.error(ex);
                    alert("Initial load failed: " + this.utilityService.getExceptionMessage(ex));
                })
                .then(() => this.utilityService.hideLoading());
        }

        $onChanges(changesObj) {
            if (changesObj.claimType) {
                this.claimInterface = claimTypes.filter(p => p.type === this.claimType)
                    .map(p => p.interfaceType)[0];
            }
        }

        loadInitialData() {
            const corporationsLoaded = this.loadIcdCorporations();
            const officesLoaded = this.loadIcdOffices();
            const divisionsLoaded = this.loadDivisions();
            const teamsLoaded = this.loadTeams();
            const rolesLoaded = this.loadRoles();

            return this.$q.all([corporationsLoaded, officesLoaded, divisionsLoaded, rolesLoaded, teamsLoaded]);
        }
        loadIcdCorporations() {
            return this.icdCorporationService.retrieveIcdCorporations()
                .then(icdCorporations => this.icdCorporations = icdCorporations.map(corporation => ({
                    Value: corporation.Id.toString(),
                    Text: corporation.ClientName + (corporation.ClientAs != null ? ' - ' + corporation.ClientAs : '')
                })).sort((a, b) => a.Text < b.Text ? -1 : 1));
        }

        loadIcdOffices() {
            this.icdOfficeService.retrieveIcdOffices()
                .then(icdOffices => this.icdOffices = icdOffices.map(office => ({
                    value: office.Id.toString(),
                    text: `${office.OwnerName} - ${office.IcdCorporationName} (${office.OfficeName})`
                })).sort((a, b) => a.text < b.text ? -1 : 1));
        }

        loadDivisions() {
            this.divisionService.retrieveDivisions()
                .then(divisions => this.divisionList = divisions.map(division => ({
                    value: division.Id.toString(),
                    text: `${division.Id} - ${division.Name}`
                })).sort((a, b) => a.text < b.text ? -1 : 1));
        }

        loadRoles() {
            this.roleService.retrieveV2Roles()
                .then(roles => roles.filter(role => role.Scope !== "Hidden")
                    .map(role => ({
                        value: role.RoleID.toString(),
                        text: role.Name
                    })).sort((a, b) => a.text < b.text ? -1 : 1))
                .then(roles => {
                    roles.unshift({
                        value: ROLES_ALL,
                        text: "All Roles"
                    });
                    this.roles = roles;
                });
        }

        loadTeams() {
            this.teamService.retrieveTeams()
                .then(teams =>
                    this.teams = teams.map(team => ({
                        value: team.TeamID.toString(),
                        text: team.Name
                    })).sort((a, b) => a.text < b.text ? -1 : 1));
        }
    }
}
